import type { ItemsDroppedEvent } from '../pages/search/components/search-page-interfaces';
import type { DroppableItem } from '@mimir/client-common/util/droppedItems';
import { showSimpleDialogFromRequest } from './simple';
import type { SimpleDialogRequest } from './simpleDialogRequest';
import type { BaseDialogProps } from './types';

/**
 * Show a simple dialog with a confirm and cancel button, the text can be configured
 * through dialogProps.
 *
 * @param dialogProps The props to configure the dialog
 * @param actionFn The synchronous callback to call when the user confirms the dialog, if any.
 * @param payload The first 'ItemsDroppedEvent' parameter for actionFn
 * @param selectedItems The second 'DroppableItem[]' parameter for actionFn
 */
export function showMoveOrCopyDialog(
  dialogProps: BaseDialogProps,
  actionFn: (payload: ItemsDroppedEvent, selectedItems: DroppableItem[]) => Promise<void>,
  payload: ItemsDroppedEvent,
  selectedItems: DroppableItem[]
) {
  const req: SimpleDialogRequest = {
    dialogProps: {
      closeOnActionClick: true,
      maxWidth: 450,
      ...dialogProps,
    },
    callback: (response) => {
      if (response === 'ok') {
        if (actionFn) {
          void actionFn(payload, selectedItems);
        }
      }
    }
  };

  showSimpleDialogFromRequest(req);
}
